<template>
  <div
    class="upload-group"
    :class="[inputGroupClass]"
  >
    <label
        class="upload-label"
        for="upload-input"
        :class="{ 'has-error ': error }"
        v-if='label'
    >
        {{ label  }}
    </label>
    <div class="upload-group__panel">
      <div :class="[
        inputClasses,
        {
            'upload-container': true,
            'has-border': !image.default
        }]"
        :style="inputStyles"
        for="upload-input"
        ref='uploadContainer'
        >
        <label for="uploadInput" class='upload-control'> + </label>
        <img :src='image.src' :alt='image.filename' ref='file'/>
      </div>
      <input
        id="uploadInput"
        :class="[inputClasses, { 'has-error ': error }]"
        type="file"
        v-bind="$attrs"
        v-on:change="handleFileChange"
        hidden
      />
    </div>
    <transition name="slide">
      <span v-show="error" class="upload-feedback is-danger">{{ error }}</span>
    </transition>
  </div>
</template>

<script>
/* eslint-disable arrow-parens */
/* eslint-disable func-names */
/* eslint-disable global-require */
import themeSetupMixin from '@/mixins/theme';

export default {
  mixins: [themeSetupMixin],
  props: {
    validator: {
      type: Function,
      default: null,
    },
    error: String,
    label: String,
    /**
     * ClassNames for input group
    */
    inputGroupClass: {
      type: String,
      default: '',
    },
    /**
     * ClassNames for input
    */
    inputClasses: {
      type: String,
      default: '',
    },
    /**
     * Inline Styles for input
    */
    inputStyles: {
      type: String,
      default: '',
    },
    /**
     *  file URL as string
    */
    file: {
      type: String,
      validator: string => {
        try {
          return Boolean(new URL(string));
        } catch (e) {
          return false;
        }
      },
    },
  },
  data() {
    return {
      image: {
        src: require('@/assets/images/upload-placeholder.png'),
        default: true,
        filename: 'image blob',
      },
    };
  },
  mounted() {
    if (this.file) {
      this.createImage(this.file, true);
    }
  },
  methods: {
    handleFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.$emit('change', e);
      this.createImage(files[0]);
    },
    /**
     * @param file URL || fileObject
     * @param fromUrl Boolean
    */
    createImage(file, fromUrl) {
      const URL = window.URL || window.webkitURL;
      const image = new Image();
      const vm = this;

      const objectUrl = (fromUrl) ? file : URL.createObjectURL(file);
      image.src = objectUrl;
      this.image.src = objectUrl;
      this.image.default = false;

      image.onload = function () {
        const width = this.width + 50;
        vm.$refs.uploadContainer.style.maxWidth = `${width}px`;
        URL.revokeObjectURL(objectUrl);
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-group {
  .upload-label {
    font-size:1rem;
    padding-bottom: 2px;
    font-size: 14px;
    line-height: 23px;
    color: var(--primary-10);
    &.has-error {
        color: var(--failed-20);
    }
  }
  .upload-container{
    background: var(--brand-white);
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;
    max-width:120px;
    text-align: center;
    &.has-border{
        border: 1.5px solid  var(--primary-60);
        padding:2px;
    }
    .upload-control {
        position: absolute;
        background:var(--brand-light);
        padding:3px 8px;
        border-radius:3px;
        right:-5px;
        top:-5px;
        color:var(--brand-white);
        font-weight:400;
        font-size:1.2rem;
    }
    img {
        width:auto;
        max-width: 100%;
        margin:0;
        height:auto;
    }
  }
}
</style>
